import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles((theme) => ({
  formHeader: {
    display: 'flex',
    flexDirection: 'row'
  },
  fieldRow: {
    display: 'block',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between'
    }
  },
  containerCheckbox: {
    marginLeft: theme.spacing(1),
    marginBlock: -5,
    '& span': {
      fontSize: 'small'
    }
  },
  field: {
    margin: theme.spacing()
  },
  fieldTexttarea: {
    margin: theme.spacing(),
    width: '100%',
    padding: 8,
    borderRadius: 4,
    fontFamily: 'sans-serif'
  },
  fieldEditorText: {
    margin: theme.spacing(),
    width: '100%',
    borderRadius: 5,
    fontFamily: 'sans-serif',
    minHeight: 160,
    lineHeight: 1.2
  },
  buttons: {
    margin: theme.spacing(1)
  },
  actionsContainer: {
    borderTop: 'solid 1px',
    borderTopColor: theme.palette.grey[400],
    marginTop: theme.spacing(2),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(),
    '& button': {
      marginRight: theme.spacing()
    }
  }
}))

export default useStyles
